<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :modalAppendToBody="true"
    :appendToBody="true"
    :classDialog="'add-people-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Chia sẻ thông tin lịch tuần</h3>
      <el-row :gutter="12" class="margin-bottom-10">
        <el-col :span="24" class="flex-row flex__left">
          <el-select
            placeholder="Gõ tên/email/đơn vị/chức danh để bắt đầu tìm kiếm"
            class="style-fullWidth input-border__bottom input-border__radius__0"
            v-model="selectedUserDeptRoleIds"
            multiple
            filterable
            remote
            reserve-keyword
            :remote-method="filterUserDeptRoleByRemote"
            :loading="isLoading"
            @visible-change="selectedUserDeptRoleIdChanged"
          >
            <el-option
              v-for="item in userDeptRoles"
              :key="item.id"
              :label="getReceiverLabel(item)"
              :value="item.id"
            >
              {{ getReceiverLabel(item) }}
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-table
        ref="multipleTable"
        :data="selectedUserDeptRoles"
        style="width: 100%"
        size="mini"
        :show-header="false"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip>
          <template slot-scope="scope" class="">
            <span class="userShortInfo">
              <strong class="name">{{ scope.row.fullName }}</strong>
              <span>
                {{ scope.row.positionName || scope.row.roleName }} -
                {{ scope.row.deptName }}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="50">
          <template slot-scope="scope">
            <span @click="removeUser(scope.row)">
              <i
                class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red"
              ></i>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="submit"
          :disabled="
            !selectedUserDeptRoles ||
            !selectedUserDeptRoles.length ||
            isProcessing
          "
        >
          <i
            :class="[!isProcessing ? 'fas fa-check-circle' : 'el-icon-loading']"
          ></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="cancel">
          <i class="fas fa-ban"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import h from "../../../services/h";
import CustomDialog from "../../common/custom-dialog";
import hcCaseCalendarService from "../../../services/hcCaseCalendarService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";

export default {
  name: "hcCaseCalendar-sharing-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "hcCaseCalendarId"],
  components: { CustomDialog },
  data() {
    return {
      selectedUserDeptRoleIds: null,
      selectedUserDeptRoles: [],
      userDeptRoles: [],
      isLoading: false,
      isProcessing: false,
    };
  },
  methods: {
    removeUser(user) {
      this.selectedUserDeptRoles = this.selectedUserDeptRoles.filter(
        (item) => item.id !== user.id
      );
    },

    selectedUserDeptRoleIdChanged(event) {
      if (event) return;
      let selectedUserDeptRoles = [];
      h.each(this.selectedUserDeptRoleIds, (selectedUserDeptRoleId) => {
        let selectedUserDeptRole = h.find(
          this.userDeptRoles,
          (item) => item.id === selectedUserDeptRoleId
        );
        if (
          selectedUserDeptRole &&
          !h.exists(
            this.selectedUserDeptRoles,
            (item) => item.id === selectedUserDeptRole.id
          )
        ) {
          selectedUserDeptRoles.push(selectedUserDeptRole);
        }
      });
      this.selectedUserDeptRoles.push(...selectedUserDeptRoles);
      this.selectedUserDeptRoleIds = [];
    },

    filterUserDeptRoleByRemote(query) {
      this.isLoading = true;
      (query && query.trim()
        ? userDeptRoleViewService
            .findAllForSharingHcCaseCalendar(
              this.hcCaseCalendarId,
              query.trim(),
              {
                sort: "fullName,asc",
              }
            )
            .then((response) => response.data)
        : Promise.resolve([])
      )
        .then((userDeptRoles) => (this.userDeptRoles = userDeptRoles))
        .then(() => (this.isLoading = false));
    },

    getReceiverLabel(userDeptRole) {
      return `${userDeptRole.fullName} (${userDeptRole.positionName} - ${userDeptRole.deptName})`;
    },

    submit() {
      this.isProcessing = true;
      let submitForm = {
        userDeptRoleIds: h.collect(
          this.selectedUserDeptRoles,
          (item) => item.id
        ),
      };
      return hcCaseCalendarService
        .share(this.hcCaseCalendarId, submitForm)
        .then(() => {
          this.notify(
            "Thông báo",
            "Chia sẻ thông tin lịch tuần thành công",
            "success",
            2000
          );
          this.isProcessing = false;
          this.$emit("success");
        })
        .catch((error) => {
          this.isProcessing = false;
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/hcCaseCalendar-sharing-dialog.vue